import React, { useEffect, useState } from 'react'
import { v3_save_document_file, v3_ship_wise_document_list, v3_upload_document } from '../../../actions/v3/document'
import moment from 'moment'
import { getAuthHeader } from '../../../utils'
import axios from 'axios'
import { toast } from 'react-toastify'
import fileDownload from 'js-file-download';
import FileDropdownPreviewMenu from '../../common/FileDropdownPreviewMenu';
import { Link } from 'react-router-dom/cjs/react-router-dom.min';
import constant from '../../../constant';
import { sortDocumentsByReportDate, sortDocumentsBySubjectAndReportDate } from '../../../utils/documentSort';
import { uploadSelectedFiles } from '../../../utils/multipleFileUpload';
import AdminDeleteButton from '../../common/AdminDeleteButton';


const Index = ({ shipId, refresh, setRefresh, selectedDocument, setSelectedDocument, payload, encodedData, selectedShip }) => {
    const [documents, setDocuments] = useState([])
    const [sortBy, setSortBy] = useState('default')
    useEffect(() => {
        
        if (shipId) {
            setSelectedDocument('')
            v3_ship_wise_document_list(shipId, payload).then((res) => {
                if (res.status) {
                    setDocuments(sortDocumentsBySubjectAndReportDate(res.result.documents))
                    // if (selectedDocument?.DOCUMENT_ID) { // check if selectedDocument exists
                    //     const latestDocument = res.result.documents.find(doc => doc.DOCUMENT_ID === selectedDocument.DOCUMENT_ID);

                    //     if (latestDocument) {
                    //         setSelectedDocument(latestDocument); // update with latest info
                    //     }
                    // }
                }
            })
        }
        else {
            setDocuments([])
        }
    }, [shipId, refresh, payload])

    const displayedDocuments = sortBy === 'monthYear'
        ? sortDocumentsByReportDate(documents)
        : sortBy === 'section'
        ? [...documents].sort((first, second) => {
            const sectionOrder = String(first?.DOCUMENT_TYPE || '').localeCompare(
                String(second?.DOCUMENT_TYPE || ''),
                undefined,
                { numeric: true, sensitivity: 'base' }
            );
            if (sectionOrder !== 0) return sectionOrder;
            return String(first?.DOCUMENT_NAME || '').localeCompare(
                String(second?.DOCUMENT_NAME || ''),
                undefined,
                { numeric: true, sensitivity: 'base' }
            );
        })
        : sortBy === 'modifiedOn'
            ? [...documents].sort((first, second) => {
                const firstModifiedOn = Date.parse(first?.MODIFIED_ON || '') || 0;
                const secondModifiedOn = Date.parse(second?.MODIFIED_ON || '') || 0;
                return secondModifiedOn - firstModifiedOn;
            })
            : documents

    const handleDownload = async (documentId) => {
        try {
            const downloadUrl = `${process.env.REACT_APP_BASE_URL}/v3/document/download/files/${documentId}`;
            let config = { responseType: 'blob' }
            const authHeader = getAuthHeader();
            if (authHeader?.headers) {
                config.headers = {
                    ...config.headers,
                    ...authHeader.headers,
                };
            }
            const response = await axios.get(downloadUrl, config);

            // const response = await axios.get(downloadUrl, getAuthHeader());

            const blob = new Blob([response.data], { type: 'application/zip' });
            const url = window.URL.createObjectURL(blob);

            const link = document.createElement('a');
            link.href = url;

            link.setAttribute('download', `document_${documentId}_files.zip`);
            document.body.appendChild(link);
            link.click();
            link.remove();

            window.URL.revokeObjectURL(url);

        } catch (error) {
            console.error('Download failed:', error?.response?.data || error.message);
            alert("Download failed. Please check if the document has valid files or contact support.");
        }
    };

    const handleUploadNewFile = async (files, documentId) => {
        try {
            const uploadedFiles = await uploadSelectedFiles(files, v3_upload_document);
            if (!uploadedFiles.length) {
                toast.error("Upload failed.");
                return;
            }

            const saveResults = await Promise.all(uploadedFiles.map((file) => v3_save_document_file({
                ...file,
                documentId
            })));

            const savedCount = saveResults.filter((result) => result?.status).length;
            if (savedCount) {
                toast.success(`${savedCount} file${savedCount === 1 ? '' : 's'} uploaded.`);
                setRefresh(!refresh);
            }
            if (savedCount !== uploadedFiles.length) {
                toast.error('Some file metadata could not be saved.');
            }
        } catch (err) {
            console.error("Upload error:", err);
            toast.error("Something went wrong during upload.");
        }
    };



    const handleDownloadFile = async (documentId, fileName, downloadName = fileName) => {
        try {
            let config = { responseType: 'blob' }
            const authHeader = getAuthHeader();
            if (authHeader?.headers) {
                config.headers = {
                    ...config.headers,
                    ...authHeader.headers,
                };
            }
            const response = await axios.get(
                `${process.env.REACT_APP_BASE_URL}/v3/document/download/file/${documentId}/${encodeURIComponent(fileName)}`,
                config
            );

            fileDownload(response.data, downloadName);
        } catch (error) {
            console.error("Download failed:", error);
            toast.error("Failed to download file.");
        }
    };

    return (
        <div className="card card-idex-doc bsn">
            <div className="card-body card-body-document">
                <div className="d-flex justify-content-end mb-2">
                    <label className="d-flex align-items-center mb-0">
                        <span className="me-2">Sort by</span>
                        <select
                            className="form-select form-select-sm"
                            aria-label="Sort documents"
                            value={sortBy}
                            onChange={(event) => setSortBy(event.target.value)}
                            style={{ width: 180 }}
                        >
                            <option value="default">Default order</option>
                            <option value="monthYear">Month &amp; Year</option>
                            <option value="section">Section</option>
                            <option value="modifiedOn">Modified On</option>
                        </select>
                    </label>
                </div>
                <div className="table-responsive table-responsive-document">
                    <table className="table align-middle table-nowrap table-hover">
                        <thead className="table-light">
                            <tr>
                                <th scope="col">Document</th>
                                <th scope="col">Files</th>
                                <th scope="col">Modified On</th>
                                <th scope="col">Notes</th>
                                <th scope="col">Created By</th>
                                <th scope="col">Action</th>
                            </tr>
                        </thead>
                        <tbody>
                            {displayedDocuments.map((item) => {
                                return (
                                    <React.Fragment>

                                        <tr key={item.DOCUMENT_ID}
                                            onClick={() => { setSelectedDocument(item) }}
                                            className={`${selectedDocument.DOCUMENT_ID === item.DOCUMENT_ID ? 'active' : ''} `}
                                        >
                                            <td>
                                                <h5 className="font-size-14 mb-1">
                                                    <a href="javascript:void(0)" className="text-dark">
                                                        {item.DOCUMENT_NAME}
                                                    </a>
                                                </h5>
                                                <span
                                                    className="badge rounded-pill bg-info"
                                                    style={{
                                                        backgroundImage:
                                                            "linear-gradient(90deg, #0ddcef, #319bfc)",
                                                        fontSize: 11
                                                    }}
                                                >
                                                    {item.DOCUMENT_TYPE}
                                                </span>
                                            </td>
                                            <td>
                                                <div className="dropdown hover-dropdown">
                                                    <span
                                                        className="text-muted mb-0 dropdown-toggle"
                                                        role="button"
                                                    >
                                                        {item.FILE_COUNT} Files{" "}
                                                        <span style={{ color: "#08c" }}>
                                                            <i
                                                                className="fa fa-download"
                                                                style={{ color: "#f46a6a" }}
                                                                aria-hidden="true"
                                                            />
                                                        </span>
                                                    </span>
                                                    <FileDropdownPreviewMenu
                                                        files={(item.files || []).map((file, index) => {
                                                            const rawFileName = file.FILE_NAME || file.fileName || '';
                                                            const encodedFileName = encodeURIComponent(rawFileName);
                                                            const displayName = file.ORIGINAL_FILE_NAME || file.originalFileName || rawFileName || `File ${index + 1}`;
                                                            return {
                                                                id: `${item.DOCUMENT_ID}-${rawFileName || 'file'}-${index}`,
                                                                name: displayName,
                                                                previewUrl: rawFileName
                                                                    ? `${process.env.REACT_APP_BASE_URL}/v3/document/preview/file/${item.DOCUMENT_ID}/${encodedFileName}`
                                                                    : '',
                                                                downloadUrl: rawFileName
                                                                    ? `${process.env.REACT_APP_BASE_URL}/v3/document/download/file/${item.DOCUMENT_ID}/${encodedFileName}`
                                                                    : '',
                                                                onDownload: rawFileName
                                                                    ? () => handleDownloadFile(item.DOCUMENT_ID, rawFileName, displayName)
                                                                    : null,
                                                            };
                                                        })}
                                                        onDownloadAll={() => handleDownload(item.DOCUMENT_ID)}
                                                    />
                                                </div>
                                            </td>

                                            <td>
                                                <p className="text-muted mb-0">
                                                    <span style={{ color: "#08c !important" }}>
                                                        {item.MODIFIED_ON
                                                            ? moment(item.MODIFIED_ON).format('DD MMM, YYYY')
                                                            : "N/A"}
                                                    </span>
                                                </p>
                                            </td>

                                            <td>
                                                <p className="text-muted mb-0">
                                                    <a href="javascript:void(0)">
                                                        <i className="fa fa-comments" aria-hidden="true" /> ({item.COMMENT_COUNT})
                                                    </a>
                                                </p>
                                            </td>
                                            <td>
                                                <p className="text-muted mb-0">{item.CREATED_BY_NAME}</p>
                                            </td>
                                            <td>
                                                <ul className="list-inline font-size-20 contact-links mb-0">
                                                    <li className="list-inline-item px-0">
                                                        <Link
                                                            to={{
                                                                pathname: constant.Authedcomponent.editDocument.url,
                                                                state: {
                                                                    document: item,
                                                                    projectData: encodedData,
                                                                    selectedShip
                                                                },
                                                            }}
                                                            title="Edit"
                                                            onClick={(event) => event.stopPropagation()}
                                                        >
                                                            <i className="bx bx-edit" />
                                                        </Link>
                                                    </li>

                                                    <li className="list-inline-item px-0">
                                                        <a
                                                            href="javascript:void(0)"
                                                            title="Upload More"
                                                            onClick={() =>
                                                                document.getElementById(`upload-document-${item.DOCUMENT_ID}`).click()
                                                            }
                                                        >
                                                            <input
                                                                type="file" // ✅ REQUIRED for file upload
                                                                id={`upload-document-${item.DOCUMENT_ID}`}
                                                                style={{ display: 'none' }}
                                                                multiple
                                                                onChange={(e) => handleUploadNewFile(e.target.files, item.DOCUMENT_ID)}
                                                            />
                                                            <i className="bx bx-upload" />
                                                        </a>
                                                    </li>

                                                    <li className="list-inline-item px-0">
                                                        <a
                                                            href="javascript:void(0)"
                                                            title="Download all files"
                                                            onClick={() => handleDownload(item.DOCUMENT_ID)}
                                                        >
                                                            <i className="bx bx-download" />
                                                        </a>
                                                    </li>
                                                    <li className="list-inline-item px-0">
                                                        <AdminDeleteButton resource="document" entryId={item.DOCUMENT_ID}
                                                            label="document" onDeleted={() => {
                                                                setSelectedDocument('');
                                                                setRefresh(value => !value);
                                                            }} />
                                                    </li>
                                                </ul>
                                            </td>
                                        </tr>

                                    </React.Fragment>

                                )
                            })}
                            {documents.length === 0 && (
                                <tr>
                                    <td colSpan="6" className="text-center text-muted">
                                        No documents found for this ship.
                                    </td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                </div>

            </div>
        </div>


    )
}

export default Index
